import React from 'react';
import GroupingAnswerChip from './GroupingAnswerChip';
import styles from './Grouping.module.scss';

export default function EachAnswerGrouping({ answers = [] }) {
  if (answers.length === 0) {
    return (
      <p className={styles.hint}>
        This question has no answers to form cohorts.
      </p>
    );
  }

  return (
    <ul className={styles.chipList}>
      {answers.map((answer) => (
        <GroupingAnswerChip key={answer.id ?? answer.value} answer={answer} />
      ))}
    </ul>
  );
}
